import {handleDeleteListing} from "./frontend/manage-listing.js";
// Window loaded bind events.
jQuery(document).ready(function ($) {
	// Bind events.
	handleDeleteListing();
});
